<template>
  <b-container class="mt-5" style="max-width: 400px;">
    <b-card>
      <h4 class="text-center mb-3">Iniciar Sesión</h4>
      <b-form @submit.prevent="handleLogin">
        <b-form-group label="Email">
          <b-form-input v-model="email" type="email" required></b-form-input>
        </b-form-group>
        <b-form-group label="Contraseña">
          <b-form-input v-model="password" type="password" required></b-form-input>
        </b-form-group>
        <b-button type="submit" variant="primary" block>Entrar</b-button>
      </b-form>

      <div v-if="registerMode" class="mt-3">
        <b-form @submit.prevent="handleRegister">
          <b-form-group label="Nombre">
            <b-form-input v-model="name" required></b-form-input>
          </b-form-group>
          <b-form-group label="Email">
            <b-form-input v-model="email" type="email" required></b-form-input>
          </b-form-group>
          <b-form-group label="Contraseña">
            <b-form-input v-model="password" type="password" required></b-form-input>
          </b-form-group>
          <b-button type="submit" variant="success" block>Registrar</b-button>
        </b-form>
      </div>
    </b-card>
  </b-container>
</template>

<script>
export default {
  data() {
    return {
      email: "",
      password: "",
      name: "",
      registerMode: false,
    };
  },
  methods: {
    async handleLogin() {
      try {
        await this.$store.dispatch("auth/login", {
          email: this.email,
          password: this.password,
        });
        this.$router.push("/");
      } catch (e) {
        alert("Credenciales inválidas");
      }
    },
    async handleRegister() {
      try {
        await this.$store.dispatch("auth/register", {
          name: this.name,
          email: this.email,
          password: this.password,
        });
        this.$router.push("/");
      } catch (e) {
        alert("Error al registrarse");
      }
    },
  },
};
</script>
